import { jsx as _jsx } from "react/jsx-runtime";
import { KeyboardDatePicker as KeyboardDatePickerMui } from '@material-ui/pickers';
import { useTheme } from '../../themes';
export { DatePicker, TimePicker, DateTimePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
export const KeyboardDatePicker = (props) => {
    const { name: themeName } = useTheme();
    return (_jsx(KeyboardDatePickerMui, Object.assign({}, props, (themeName === 'liquidity' && { KeyboardButtonProps: { color: 'primary' } })), void 0));
};
//# sourceMappingURL=Pickers.js.map